module.exports = __webpack_public_path__ + "media/images/pc/specials/fair/title_deco-b23f9d0ee8efb488dbcd84ce12f888c5.svg";